import React, {useEffect, useState} from "react";
import { useSearch } from "../../Contexts/SearchContext";
import ListItem from "../../ListItem";
import "./SearchResults.scss";
import { getCategoryLabel } from "../../../helpers/site-search";
import { truncate, truncateLong } from "../../../helpers/strings";

const SearchResults = ({ emptyResults }) => {
  const { state, dispatch } = useSearch();
  const {
    searchTerm,
    filteredResults,
    resultsToShow_mobile,
    resultsToShow_tablet,
    resultsToShow_desktop,
    resultsToShowStepSize_mobile,
    resultsToShowStepSize_tablet,
    resultsToShowStepSize_desktop,
    componentType,
  } = state;

  const [pageDepth, setPageDepth] = useState(1);

  useEffect(() => {
    setPageDepth(1);
  }, [searchTerm]);

  const updateResultsToShow = () => {
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_MOBILE",
      payload: resultsToShow_mobile + resultsToShowStepSize_mobile,
    });
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_TABLET",
      payload: resultsToShow_tablet + resultsToShowStepSize_tablet,
    });
    dispatch({
      type: "UPDATE_RESULTS_TO_SHOW_DESKTOP",
      payload: resultsToShow_desktop + resultsToShowStepSize_desktop,
    });

    showMoreLinkAnalytics();
  };

  function showMoreLinkAnalytics() {
    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.linkClick,
      linkDetails: {
        clickName: 'Search Show more',
        clickType: 'Link',
        clickDestination: '',
        clickLocation: 'Main Container',
        searchDetails: {
          searchTerm: searchTerm,
          type: 'Site search',
          pageDepth: pageDepth + 1,
        }
      }
    });
    setPageDepth(pageDepth + 1);
  }

  let showMoreLinkClasses = "";

  const getItemData = (item) => {
    const listItem = {};

    const { Fields } = item;
    const {
      pagePath,
      pageTitle_product,
      pageDescription_product,
      formattedPageTags,
    } = Fields;
    const categories = JSON.parse(formattedPageTags?.Value);

    listItem.category = getCategoryLabel(categories);
    listItem.pagePath = pagePath.Value;
    listItem.title = pageTitle_product?.Value;
    listItem.highlightedTitle = highlightTerm(truncate(pageTitle_product?.Value), searchTerm);
    listItem.description = highlightTerm(truncateLong(pageDescription_product?.Value), searchTerm);
    return listItem;
  };

  const highlightTerm = (text, term) => {
    if (!text || !term) return text;
    let highlightedText = text;
    const words = term.split(" ");
    for (let i = 0; i < words.length; i += 1) {
      highlightedText = highlightedText.replace(new RegExp(`(${words[i]})`, "ig"), '<b>$1</b>');
    }
    return highlightedText;
  }

  // renders
  return (
    <>
      <div className="site-search-results__top-border"></div>
      <div
        id="search-top"
        className="search-results site-search-results-section"
      >
        {filteredResults?.map((result, index) => {
          let showHideClasses = "";
          showMoreLinkClasses = "";
          if (index >= resultsToShow_mobile) {
            showHideClasses += " hidden-mobile";
            showMoreLinkClasses += " show-mobile";
          }

          if (index >= resultsToShow_tablet) {
            showHideClasses += " hidden-tablet";
            showMoreLinkClasses += " show-tablet";
          }

          if (index >= resultsToShow_desktop) {
            showHideClasses += " hidden-desktop";
            showMoreLinkClasses += " show-desktop";
          }

          return (
            <ListItem
              key={index}
              {...getItemData(result)}
              showHide={showHideClasses}
              clickTrackingEnabled={false}
              componentType={componentType}
              index={index}
            />
          );
        })}
        <div className="cmp-listitem dummy-listitem hidden-mobile"></div>
        <div className="cmp-listitem dummy-listitem hidden-mobile hidden-tablet"></div>
      </div>
      {filteredResults && showMoreLinkClasses !== "" && (
        <div
          className={`site-search-show-more-link-container${showMoreLinkClasses}`}
        >
          <a
            href={void 0}
            className="site-search-show-more-link"
            onClick={updateResultsToShow}
          >
            <span>Show More</span>
            <i className="icon" />
          </a>
        </div>
      )}
      {!filteredResults.length && (
        <div
          className="empty-results"
          dangerouslySetInnerHTML={{ __html: emptyResults }}
        />
      )}
    </>
  );
};

export default SearchResults;
